<template>
  <v-container fluid>
    <material-card v-if="parentdata.franchiseeID" :title="'Enquiry Form'" inline icon="mdi-mail">
      <form @submit.prevent="saveEnquiryV1">
        <div>
          <AdmissionElement @franchiseeOpt="franchiseeCheck($event)" ref="admissionElement" v-model="parentdata" :formType="this.formType" />
        </div>
        <div>
          <StudentElement isWritable="true" v-model="parentdata" :formType="this.formType" />
        </div>
        <div>
          <ParentElement isWritable="true" parentType="father" v-model="parentdata" formType="enquiry" />
        </div>
        <div>
          <ParentElement isWritable="true" parentType="mother" v-model="parentdata" formType="enquiry" />
        </div>
        <div>
          <AddressElement isWritable="true" v-model="parentdata" :formType="this.formType" />
        </div>

        <v-card-actions class="d-flex justify-end">
          <v-btn bottom right elevation="1" color="primary" type="submit">
            <v-icon left> mdi-content-save </v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </form>
    </material-card>
    <div v-else>
    <section class="">
      <div class="level-item">
        <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" />
      </div>
      <div class="level-item">
        <p class="title is-2">Enquiry link is invalid!</p>
      </div>
      <br />
    </section>
    <!-- <section class="container section page-header section is-main-section">
      <p class="title is-4" style=" text-align: center;">Form saved successfully. Thank you !!</p>
    </section> -->
  </div>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

import StudentElement from '@/components/Forms/Elements/StudentElement'
import AdmissionElement from '@/components/Forms/Elements/AdmissionElement'
import ParentElement from '@/components/Forms/Elements/ParentElement'
import AddressElement from '@/components/Forms/Elements/AddressElement'

import _ from 'lodash'
import moment from 'moment'
import Utils from '@/utils'
export default {
  name: 'qrcodeEnquiryForm',
  props: ['fid'],
  components: {
    MaterialCard,
    StudentElement,
    AdmissionElement,
    ParentElement,
    AddressElement
  },
  data: function () {
    return {
      formType: 'createEnquiryQR',
      parentdata: {
        franchiseeID: '',
        countryName: 'India'
      },
      isLoading: false,
      enableAdmission: false
    }
  },
  async mounted () {
    // this.onstart()
    await this.decodeFranchisee()
  },
  methods: {
    saveEnquiryV1: async function () {
      try {
        if (!this.parentdata.gender) {
          return this.$buefy.dialog.alert({
            message: 'Gender is required!',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (!this.parentdata.dateOfBirth) {
          return this.$buefy.dialog.alert({
            message: 'Date of birth is required!',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        await http.post(`${constants.API_URL}/api/enquiry`, _.assign(this.parentdata, { formType: 'QR' }))
        this.$router.push({ name: 'qrcodeEnquiryThankyou' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    saveEnquiry: async function () {
      if (this.parentdata.isFollowUp === 'true') {
        if (_.isEmpty(this.parentdata.followUpDateTime)) {
          this.hasClicked = false
          return this.$dialog.error({
            text: 'Please select next followup date & time',
            title: 'Error'
          })
        }
      }
      if (this.enquiryCode) {
        try {
          this.hasClicked = true
          this.loader = true
          this.parentdata.address1 = this.parentdata.address
          this.parentdata.followUpDateTime = moment(this.parentdata.followUpDateTime).format('YYYY-MM-DD HH:mm:ss')
          const nextFollowup = this.parentdata.followUpDateTime
          const actionRemarks = this.parentdata.actionRemarks
          const enquiryResponse = this.parentdata.enquiryResponse
          const currentStatus = this.parentdata.enquiryStageID
          const isFollowUp = this.parentdata.isFollowUp
          delete this.parentdata.enquiryStageID
          delete this.parentdata.dateOfEnquiry
          delete this.parentdata.enquiryDateTime
          delete this.parentdata.isSendEmail
          delete this.parentdata.followUpDateTime
          delete this.parentdata.nextFollowup
          delete this.parentdata.actionRemarks
          delete this.parentdata.enquiryResponse
          delete this.parentdata.currentStatus
          delete this.parentdata.isFollowUp
          delete this.parentdata.message

          let formData = {
            id: this.parentdata.id,
            address1: this.parentdata.address,
            followUpDateTime: this.parentdata.followUpDateTime,
            message: this.message
          }
          delete this.parentdata.address
          _.assign(formData, this.parentdata)

          await http.put(`${constants.API_URL}/api/update-enquiry`, formData)
          if (isFollowUp === 'true') {
            const formDataFollowUps = {
              enquiryCode: this.enquiryCode,
              nextFollowup: nextFollowup,
              actionRemarks: actionRemarks,
              enquiryResponse: enquiryResponse,
              currentStatus: currentStatus
              //   franchiseeID: this.enquiryDetails.franchiseeID
            }

            await http.post(`${constants.API_URL}/api/addNewFollowup`, formDataFollowUps)
          }
          let radio2 = this.radio

          if (this.type === 'Service') {
            this.$router.push({ name: 'serviceEnquiries' })
            this.$dialog.info({
              text: 'Saved successfully',
              title: 'Info'
            })
          } else {
            this.$router.push({ name: 'enquiry', params: { radio2 } })
            this.$dialog.info({
              text: 'Saved successfully',
              title: 'Info'
            })
          }
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          return this.$dialog.error({
            text: errorMessage,
            title: 'Error'
          })
        } finally {
          this.hasClicked = false
          this.loader = false
        }
      } else {
        try {
          this.loader = true
          this.hasClicked = true
          this.loader = true
          this.parentdata.dateOfEnquiry = moment(this.parentdata.dateOfEnquiry).format('YYYY-MM-DD HH:mm:ss')
          let formData = {
            initial: 'P',
            address1: this.parentdata.address,
            isSendEmail: this.isSendEmail,
            message: this.message,
            followUpDateTime: moment(this.parentdata.followUpDateTime).format('YYYY-MM-DD HH:mm:ss')
          }
          _.assign(formData, this.parentdata)
          delete formData.address
          delete formData.countryName
          delete formData.enquiryStageID

          const response = await http.post(`${constants.API_URL}/api/create-enquiry`, formData)
          if (this.parentdata.isFollowUp === 'true') {
            const formDataFollowUps = {
              enquiryCode: response.data.enquiryCode,
              nextFollowup: this.parentdata.followUpDateTime,
              actionRemarks: this.parentdata.actionRemarks,
              enquiryResponse: this.parentdata.enquiryResponse,
              currentStatus: this.parentdata.enquiryStageID
              //   franchiseeID: this.enquiryDetails.franchiseeID
            }
            await http.post(`${constants.API_URL}/api/addNewFollowup`, formDataFollowUps)
          }

          this.$router.push({ name: 'enquiry' })
          return this.$dialog.info({
            text: 'Enquiry created successfully',
            title: 'Info'
          })
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          console.log('Error While Saving Enquiry Details', errorMessage)
          return this.$dialog.error({
            text: errorMessage,
            title: 'Error'
          })
        } finally {
          this.lock = false
          this.hasClicked = false
          this.loader = false
        }
      }
    },
    async decodeFranchisee () {
      try {
        let fid = Number(Buffer.from(this.fid, 'base64'))
        if (_.isNaN(fid)) {
          return null
        }
        console.log(`Franchisee ID: ${fid}`)
        this.parentdata = {
          franchiseeID: fid
        }
        // this.enableAdmission = true
        console.log(this.parentdata)
      } catch (e) {
        console.log(e)
        this.errMsg('Invalid URL!')
      }
    },
    franchiseeCheck (evt) {
      let searchIndex = _.map(evt, a => a.id).indexOf(this.parentdata.franchiseeID)
      if (searchIndex < 0) {
        this.parentdata.franchiseeID = null
      }
    },
    childData: function (value) {
      _.assign(this.enquiry, value)
    },
    onstart: async function () {
      try {
        this.isLoading = true
        if (this.enquiryCode) {
          let response = await http.get(`${constants.API_URL}/api/enquiry/${this.enquiryCode}`)
          this.enquiryObject = response.data

          this.assignedToUser = this.enquiryObject.user
          this.parentdata = {
            id: this.enquiryObject.id,
            user: this.user,
            studentFirstName: this.enquiryObject.studentFirstName,
            studentMiddleName: this.enquiryObject.studentMiddleName,
            studentLastName: this.enquiryObject.studentLastName,
            pointOfContact: this.enquiryObject.pointOfContact,
            fatherName: this.enquiryObject.fatherName,
            fatherEmailID: this.enquiryObject.fatherEmailID,
            fatherMobile: this.enquiryObject.fatherMobile,
            fatherOccupation: this.enquiryObject.fatherOccupation,
            motherName: this.enquiryObject.motherName,
            motherEmailID: this.enquiryObject.motherEmailID,
            motherMobile: this.enquiryObject.motherMobile,
            motherOccupation: this.enquiryObject.motherOccupation,
            address1: this.enquiryObject.address1,
            city: this.enquiryObject.city,
            state: this.enquiryObject.state,
            pincode: this.enquiryObject.pincode === 0 ? '' : this.enquiryObject.pincode,
            gender: this.enquiryObject.gender,
            classID: this.enquiryObject.classID,
            academicYearID: this.enquiryObject.academicYearID,
            franchiseeID: this.enquiryObject.franchiseeID,
            dateOfEnquiry: moment(this.enquiryObject.dateOfEnquiry).format('DD/MM/YYYY HH:mm'),
            enquiryDateTime: moment(this.enquiryObject.dateOfEnquiry).format('YYYY-MM-DD HH:mm'),
            dateOfBirth: !_.isEmpty(this.enquiryObject.dateOfBirth) ? moment(this.enquiryObject.dateOfBirth, 'YYYY-MM-DD').format('YYYY-MM-DD') : '',
            address: this.enquiryObject.address1,
            countryName: 'India',
            isSendEmail: false,
            isFollowUp: false,
            message: this.enquiryObject.message,
            sourceID: this.enquiryObject.sourceID,
            enquiryStageID: '',
            enquiryResponse: '',
            followUpDateTime: '',
            actionRemarks: ''
          }

          this.message = this.enquiryObject.message
          let followStage = ''
          if (!_.isEmpty(this.enquiryObject.enquiryFollowups)) {
            let followUps = this.enquiryObject.enquiryFollowups[0]
            followStage = followUps.currentStatus
          }
          this.parentdata.enquiryStageID = followStage
          this.formType = 'editEnquiry'
          this.isLoading = false
        } else {
          const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
          this.academicYears = data.rows
          const currentAcademicYear = Utils.getCurrentAcademicYear()
          let academicYear = this.academicYears.find((y) => {
            return y.academicYear.trim() === currentAcademicYear.trim()
          })
          const dataArray = {
            fatherMobile: this.fatherMobiles,
            fatherEmailID: this.fatherEmailID,
            fatherName: this.fatherName,
            fatherOccupation: this.fatherOccupation,
            studentFirstName: this.studentName
          }
          this.parentdata = dataArray
          this.parentdata.academicYearID = this.acadmicyear = academicYear ? academicYear.id : ''
          this.parentdata.dateOfEnquiry = ''
          this.parentdata.franchiseeID = this.franchisee
          this.parentdata.isFollowUp = false
          this.parentdata.countryName = 'India'
          this.parentdata.state = ''
          this.parentdata.enquiryStageID = ''
          this.parentdata.enquiryResponse = ''
          this.parentdata.pointOfContact = ''
          this.parentdata.actionRemarks = ''
          this.parentdata.classID = ''
          this.parentdata.gender = ''
          this.formType = 'createEnquiry'
        }

        const stateresponse = await http.get(`${constants.API_URL}/api/states`)
        this.states = stateresponse.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
